import { Typography } from '@mui/material';
import React from 'react';
import { search } from 'sr-types';
import { V } from '../../../common/Layout';
import Loading from '../../../common/components/Loading';
import I18n from '../../../common/i18n/I18n';
import { BooleanFacet } from './BooleanFacet';
import { CustomComboBoxFacet } from './CustomComboBoxFacet';
import { CustomListFacet } from './CustomListFacet';
import { DateRangeFacet } from './DateRangeFacet';
import { RangeSliderFacet } from './RangeSliderFacet';
import { SingleSelectFacet } from './SingleSelectFacet';
import { TextFacet } from './TextFacet';

type FacetsListProps = {
    facets: search.SkFacetSet[];
    loading: boolean;
    promote: string[];
    showCount: boolean;
    isLocal: boolean;
    requiredFilters: string[];
    autoApply: boolean;
    onFiltersChanged: () => void;
};
export const FacetsList = (components = []) => {
    const componentTypeMap = [
        ...components,
        TextFacet,
        CustomListFacet,
        CustomComboBoxFacet,
        DateRangeFacet,
        RangeSliderFacet,
        SingleSelectFacet,
        BooleanFacet
    ].reduce((sum, component) => {
        sum[component.DISPLAY] = component;
        return sum;
    }, {});
    return (props: FacetsListProps) => {
        const {
            facets,
            loading,
            promote,
            showCount,
            isLocal,
            requiredFilters = [],
            autoApply,
            onFiltersChanged
        } = props;
        return loading ? (
            <Loading size={'16px'} sx={{ py: 2 }} />
        ) : facets && facets.length ? (
            facets.map((facet) => {
                const isPromote = promote && promote.length && promote.includes(facet.identifier);
                if (!isPromote) {
                    const Component = componentTypeMap[facet.display];
                    if (!Component) {
                        throw new Error(facet.display + ' not available');
                    }
                    return (
                        <V
                            key={`${facet.identifier}-${autoApply}`}
                            sx={{
                                p: 1,
                                pt: 2
                            }}
                        >
                            <Component
                                facet={facet}
                                requiredFilters={requiredFilters}
                                loading={loading}
                                showCount={showCount}
                                isLocal={isLocal}
                                autoApply={autoApply}
                                onFiltersChanged={onFiltersChanged}
                            />
                        </V>
                    );
                }
            })
        ) : (
            <Typography sx={{ m: 1, fontWeight: 300 }}>
                <I18n token={'error.facets.missing.message'} />
            </Typography>
        );
    };
};
